import { useEffect, useEffectEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { HeadlineM } from '#src/atoms/typography/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { tabletAndAbove } from '#src/style/mediaQuery.ts';

const SCA_MESSAGE = 'sorare:mangopay:sca-complete';

const Iframe = styled.iframe`
  display: block;
  border: none;
  width: 100%;
  height: 100%;
  margin: auto;

  @media ${tabletAndAbove} {
    width: 640px;
    height: 680px;
    max-width: 100%;
    max-height: 100%;
  }
`;

type Props = {
  open: boolean;
  mangopayScaUrl: string;
  onSuccess: () => void;
  onClose: () => void;
  onFailed: () => void;
};

export const MangopayScaIframe = ({
  mangopayScaUrl,
  open,
  onSuccess,
  onFailed,
  onClose,
}: Props) => {
  const postMessageCb = (location: string) => {
    const params = new URL(location).searchParams;
    const controlStatus = params.get('controlStatus');
    if (controlStatus) {
      if (controlStatus === 'VALIDATED') {
        onSuccess();
      } else if (controlStatus === 'REFUSED' || controlStatus === 'FAILED') {
        onFailed();
      }
    }
  };

  const latestPostMessageCallback = useEffectEvent(postMessageCb);

  useEffect(() => {
    const cb = (event: MessageEvent) => {
      if (event.data.eventId === SCA_MESSAGE) {
        latestPostMessageCallback(event.data.data.location);
      }
    };
    window.addEventListener('message', cb);

    return () => window.removeEventListener('message', cb);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      title={
        <HeadlineM className="text-center">
          <FormattedMessage
            id="MangopayScaIframe.title"
            defaultMessage="Account security"
          />
        </HeadlineM>
      }
      open={open}
      onClose={onClose}
    >
      <Iframe
        title="Mangopay SCA"
        src={mangopayScaUrl ?? ''}
        allow="publickey-credentials-get *; publickey-credentials-create *;"
      />
    </Dialog>
  );
};
